module.exports = __webpack_public_path__ + "img/playstore.35959ee7.svg";